import { render, staticRenderFns } from "./InvitesCodes.vue?vue&type=template&id=2f06bab6&scoped=true"
import script from "./InvitesCodes.vue?vue&type=script&lang=ts"
export * from "./InvitesCodes.vue?vue&type=script&lang=ts"
import style0 from "./InvitesCodes.vue?vue&type=style&index=0&id=2f06bab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f06bab6",
  null
  
)

export default component.exports